import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { BackendModule } from '@shared/datastore/core';
import { notificationsPreferencesBackend } from './notifications-preferences.backend';
import { notificationsPreferencesReducer } from './notifications-preferences.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature(
      'notificationsPreferences',
      notificationsPreferencesReducer,
    ),
    BackendModule.forFeature(
      'notificationsPreferences',
      notificationsPreferencesBackend,
    ),
  ],
})
export class DatastoreNotificationsPreferencesModule {}



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/notifications-preferences/notifications-preferences.module.ts